import React from 'react';

import type { GlobalMoreMenuProps } from '../types';

import { MoreMenuPopup } from './more-menu-popup';
import { getHiddenItems } from './utils/get-hidden-items';

export function GlobalMoreMenu({
	productItemsData,
	appItemsData = [],
	menuItemComponent,
	customizeSidebarMenuItem,
	moreMenuItemLabel,
	peekingMenuIds = [],
	onClickMoreMenuTrigger,
	testId,
	triggerRef,
	triggerVisualContentRef,
	dropIndicator,
}: GlobalMoreMenuProps) {
	const { hiddenProductItemsData, hiddenAppItemsData, shouldShowMoreMenu } = getHiddenItems(
		productItemsData,
		appItemsData,
		peekingMenuIds,
	);

	return (
		<MoreMenuPopup
			productItemsData={hiddenProductItemsData}
			appItemsData={hiddenAppItemsData}
			menuItemComponent={menuItemComponent}
			customizeSidebarMenuItem={customizeSidebarMenuItem}
			moreMenuItemLabel={moreMenuItemLabel}
			onClickMoreMenuTrigger={onClickMoreMenuTrigger}
			showMoreMenu={shouldShowMoreMenu}
			testId={testId}
			triggerRef={triggerRef}
			triggerVisualContentRef={triggerVisualContentRef}
			dropIndicator={dropIndicator}
		/>
	);
}
